"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof3 = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Accordion = _interopRequireDefault(require("../accordion/Accordion"));

var _utils = require("../common/utils.js");

var _variables = require("../common/variables.js");

var _useTheme = _interopRequireDefault(require("../useTheme"));

var _templateObject;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof3(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var AccordionGroupAccordionContext = /*#__PURE__*/(0, _react.createContext)(null);

var AccordionGroupAccordion = function AccordionGroupAccordion(_ref) {
  var childProps = (0, _extends2["default"])({}, _ref);

  var _useContext = (0, _react.useContext)(AccordionGroupAccordionContext),
      activeIndex = _useContext.activeIndex,
      handlerActiveChange = _useContext.handlerActiveChange,
      disabled = _useContext.disabled,
      index = _useContext.index;

  return /*#__PURE__*/_react["default"].createElement(_Accordion["default"], (0, _extends2["default"])({
    isExpanded: activeIndex === index,
    onChange: function onChange() {
      handlerActiveChange(index);
    },
    disabled: disabled
  }, childProps), childProps.children);
};

var DxcAccordionGroup = function DxcAccordionGroup(_ref2) {
  var defaultIndexActive = _ref2.defaultIndexActive,
      indexActive = _ref2.indexActive,
      _ref2$disabled = _ref2.disabled,
      disabled = _ref2$disabled === void 0 ? false : _ref2$disabled,
      onActiveChange = _ref2.onActiveChange,
      margin = _ref2.margin,
      children = _ref2.children;
  var colorsTheme = (0, _useTheme["default"])();

  var _useState = (0, _react.useState)(defaultIndexActive !== null && defaultIndexActive !== void 0 ? defaultIndexActive : -1),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      innerIndexActive = _useState2[0],
      setInnerIndexActive = _useState2[1];

  var handlerActiveChange = (0, _react.useCallback)(function (index) {
    indexActive !== null && indexActive !== void 0 ? indexActive : setInnerIndexActive(function (prev) {
      return index === prev ? -1 : index;
    });
    !disabled && (onActiveChange === null || onActiveChange === void 0 ? void 0 : onActiveChange(index));
  }, [disabled, indexActive, onActiveChange]);
  var contextValue = (0, _react.useMemo)(function () {
    return {
      activeIndex: indexActive !== null && indexActive !== void 0 ? indexActive : innerIndexActive,
      handlerActiveChange: handlerActiveChange,
      disabled: disabled
    };
  }, [indexActive, innerIndexActive, handlerActiveChange, disabled]);
  return /*#__PURE__*/_react["default"].createElement(_styledComponents.ThemeProvider, {
    theme: colorsTheme.accordion
  }, /*#__PURE__*/_react["default"].createElement(AccordionGroupContainer, {
    margin: margin,
    disabled: disabled
  }, (Array.isArray(children) ? children : [children]).filter(function (child) {
    return child.type === AccordionGroupAccordion;
  }).map(function (accordion, index) {
    return /*#__PURE__*/_react["default"].createElement(AccordionGroupAccordionContext.Provider, {
      key: "accordion-".concat(index),
      value: _objectSpread({
        index: index
      }, contextValue)
    }, accordion);
  })));
};

DxcAccordionGroup.Accordion = AccordionGroupAccordion;

var calculateWidth = function calculateWidth(margin) {
  return "calc(100% - ".concat((0, _utils.getMargin)(margin, "left"), " - ").concat((0, _utils.getMargin)(margin, "right"), ")");
};

var AccordionGroupContainer = _styledComponents["default"].div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  width: ", ";\n  margin: ", ";\n  margin-top: ", ";\n  margin-right: ", ";\n  margin-bottom: ", ";\n  margin-left: ", ";\n  cursor: ", ";\n\n  > div:not(:last-of-type):not(:only-of-type) {\n    border-bottom: ", ";\n    border-color: ", ";\n  }\n  > div:not(:first-of-type):not(:last-of-type):not(:only-of-type) {\n    border-radius: 0;\n    & > h3 > button {\n      border-radius: 0;\n    }\n  }\n  > div:first-of-type:not(:only-of-type) {\n    border-bottom-left-radius: 0;\n    border-bottom-right-radius: 0;\n    border-top-left-radius: ", ";\n    border-top-right-radius: ", ";\n\n    & > h3 > button {\n      border-bottom-left-radius: 0;\n      border-bottom-right-radius: 0;\n    }\n  }\n  > div:last-of-type:not(:only-of-type) {\n    border-top-left-radius: 0;\n    border-top-right-radius: 0;\n    border-bottom-left-radius: ", ";\n    border-bottom-right-radius: ", ";\n\n    & > h3 > button {\n      border-top-left-radius: 0;\n      border-top-right-radius: 0;\n    }\n  }\n"])), function (props) {
  return calculateWidth(props.margin);
}, function (_ref3) {
  var margin = _ref3.margin;
  return margin && (0, _typeof2["default"])(margin) !== "object" ? _variables.spaces[margin] : "0px";
}, function (_ref4) {
  var margin = _ref4.margin;
  return margin && (0, _typeof2["default"])(margin) === "object" && margin.top ? _variables.spaces[margin.top] : "";
}, function (_ref5) {
  var margin = _ref5.margin;
  return margin && (0, _typeof2["default"])(margin) === "object" && margin.right ? _variables.spaces[margin.right] : "";
}, function (_ref6) {
  var margin = _ref6.margin;
  return margin && (0, _typeof2["default"])(margin) === "object" && margin.bottom ? _variables.spaces[margin.bottom] : "";
}, function (_ref7) {
  var margin = _ref7.margin;
  return margin && (0, _typeof2["default"])(margin) === "object" && margin.left ? _variables.spaces[margin.left] : "";
}, function (props) {
  return props.disabled ? "not-allowed" : "pointer";
}, function (props) {
  return "".concat(props.theme.accordionGroupSeparatorBorderThickness, " ").concat(props.theme.accordionGroupSeparatorBorderStyle);
}, function (props) {
  return props.theme.accordionGroupSeparatorBorderColor;
}, function (props) {
  return props.theme.borderRadius;
}, function (props) {
  return props.theme.borderRadius;
}, function (props) {
  return props.theme.borderRadius;
}, function (props) {
  return props.theme.borderRadius;
});

var _default = DxcAccordionGroup;
exports["default"] = _default;